import React, { useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress, Chip } from '@mui/material';

interface AdvanceDialogProps {
  open: boolean;
  onClose: () => void;
  campaign: any;
}

const AdvanceDialog: React.FC<AdvanceDialogProps> = ({ open, onClose, campaign }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  if (!campaign) return null;
  const isLastLevel = campaign.currentLevelOrder >= campaign.levelsCount;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await dataProvider.create(`customer-recovery-rules/${campaign.id}/advance`, {
        data: { expectedLevelOrder: campaign.currentLevelOrder },
      });
      notify(isLastLevel ? 'Campanha finalizada' : 'Campanha avançou de nível', { type: 'success' });
      refresh();
      onClose();
    } catch (error: any) {
      notify(error.message || 'Erro ao avançar a campanha', { type: 'warning' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !loading && onClose()}>
      <DialogTitle>{isLastLevel ? 'Finalizar agora' : `Avançar para o nível ${campaign.currentLevelOrder + 1}`}</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          {isLastLevel
            ? 'Este é o último nível. Finalizar agora encerra a campanha e apaga os cupons dos clientes que não voltaram.'
            : `O nível ${campaign.currentLevelOrder} termina agora, mesmo que ainda faltem dias, e o próximo nível começa para todo mundo ativo.`}
        </Typography>
        <Chip label={`${campaign.activeCount ?? 0} cliente(s) ativos afetados`} color="info" />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button
          variant="contained"
          color={isLastLevel ? 'warning' : 'primary'}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}
          onClick={handleConfirm}
        >
          {isLastLevel ? 'Finalizar agora' : 'Avançar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdvanceDialog;
